import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { DollarSign, Users, CheckCircle, X, ArrowLeft } from "lucide-react";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";
import DatePicker from "react-datepicker";
import "../Css/DashboardPayment.css";
import Header from "../Header";
import GreyArrow from "../../assets/greyLeftAr.png";
import dropdown from "../../assets/arrow_drop_down_24px.svg";
import {
  options_select_drop_feedback,
  Analytics_text,
} from "../../CommonJquery/WebsiteText";
import {
  computeTodayDate,
  computeplussevendays,
  formatDateStringdot,
  formatTimeFormat,
  goBack,
  handleError,
} from "../../CommonJquery/CommonJquery";
import {
  server_post_data,
  payment_analytics,
} from "../../ServiceConnection/serviceconnection";
import Loader from "../Loader";
// Lazy load ApexCharts to avoid SSR issues
const ReactApexChart = lazy(() => import("react-apexcharts"));

const PaymentDashboard = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("all");
  const [hoveredBar, setHoveredBar] = useState(null);
  const [animateChart, setAnimateChart] = useState(false);
  const [customDateActive, setCustomDateActive] = useState(false);
  const [selected, setIsSelected] = useState(options_select_drop_feedback[0]);
  const [startDate, setStartDate] = useState(computeplussevendays());
  const [endDate, setEndDate] = useState(computeTodayDate());
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [transactions, settransactions] = useState([]);
  const [chartData, setchartData] = useState([]);
  const [paymentsource, setpaymentsource] = useState([]);
  const [totaldata, settotaldata] = useState([]);
  const [y_axis, sety_axis] = useState();
  // Reference to the chart component
  const chartRef = useRef(null);
  const donutChartRef = useRef(null);

  useEffect(() => {
    let start_date = "";
    let end_date = "";
    
    const today = new Date();
    const startOfToday = new Date();
    // startOfToday.setHours(0, 0, 0, 0); // 00:00:00

    // const endOfToday = new Date();
    // endOfToday.setHours(23, 59, 59, 999); // 23:59:59

    // start_date = getFormattedDate(startOfToday);
    // end_date = getFormattedDate(endOfToday);
    const hundredYearsAgo = new Date(today);
    hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
    start_date = getFormattedDate(hundredYearsAgo);
    end_date = getFormattedDate(startOfToday);
    master_data_get(start_date, end_date);
  }, []);

  const master_data_get = async (start_date, end_date) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("start_date", start_date);
    fd.append("end_date", end_date);
    await server_post_data(payment_analytics, fd)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          
          settransactions(Response.data.message.payment_data);
          setchartData(Response.data.message.service_changes);
          setpaymentsource(Response.data.message.payment_sources);
          settotaldata(Response.data.message);
          sety_axis(Response.data.message.y_axis_labels);
        }

        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        // handleError("network");
        setshowLoaderAdmin(false);
      });
  };

  // Trigger animation when component mounts
  useEffect(() => {
    setTimeout(() => {
      setAnimateChart(true);
    }, 300);
  }, []);

  // Effect to handle chart hover when card is hovered
  useEffect(() => {
    if (hoveredBar !== null && chartRef.current && chartRef.current.chart) {
      // Programmatically trigger mousemove event on the chart
      try {
        const chart = chartRef.current.chart;

        // This is a workaround to highlight the bar in ApexCharts
        // First, we need to dispatch a mouseleave event to clear any existing highlights
        chart.el.dispatchEvent(new MouseEvent("mouseleave"));

        // Then we need to find the bar element and dispatch a mousemove event on it
        setTimeout(() => {
          const seriesElements = chart.el.querySelectorAll(
            ".apexcharts-bar-series .apexcharts-series"
          );
          if (seriesElements.length > 0) {
            const barElements =
              seriesElements[0].querySelectorAll(".apexcharts-bar");
            if (barElements.length > hoveredBar) {
              const barElement = barElements[hoveredBar];
              const rect = barElement.getBoundingClientRect();
              const x = rect.left + rect.width / 2;
              const y = rect.top + rect.height / 2;

              const mouseEvent = new MouseEvent("mousemove", {
                bubbles: true,
                clientX: x,
                clientY: y,
              });

              barElement.dispatchEvent(mouseEvent);
            }
          }
        }, 10);
      } catch (error) {
        console.error("Error highlighting chart bar:", error);
      }
    }
  }, [hoveredBar]);

  const dropdownRef = useRef(null);
  const [isActive, setIsActive] = useState(false);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };
  const getFormattedDate = (date) => date.toISOString().split("T")[0];
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const select_dropdown = (itemsdata) => {
    setIsSelected(itemsdata);
    setIsActive(!isActive);

    let start_date = "";
    let end_date = "";

    const today = new Date();
    // format as YYYY-MM-DD

    switch (itemsdata.value) {
      case "today":
        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0); // 00:00:00

        const endOfToday = new Date();
        endOfToday.setHours(23, 59, 59, 999); // 23:59:59

        start_date = getFormattedDate(startOfToday);
        end_date = getFormattedDate(endOfToday);
        break;

      case "last_7_days":
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 6);
        start_date = getFormattedDate(sevenDaysAgo);
        end_date = getFormattedDate(today);
        break;

      case "this_month":
        const startOfThisMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );
        start_date = getFormattedDate(startOfThisMonth);
        end_date = getFormattedDate(today);
        break;

      case "last_month":
        const startOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          1
        );
        const endOfLastMonth = new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        );
        start_date = getFormattedDate(startOfLastMonth);
        end_date = getFormattedDate(endOfLastMonth);
        break;

      case "this_year":
        const startOfYear = new Date(today.getFullYear(), 0, 1);
        start_date = getFormattedDate(startOfYear);
        end_date = getFormattedDate(today);
        break;

      case "all":
        const hundredYearsAgo = new Date(today);
        hundredYearsAgo.setFullYear(hundredYearsAgo.getFullYear() - 100);
        start_date = getFormattedDate(hundredYearsAgo);
        end_date = getFormattedDate(today);
        break;

      case "date":
        setCustomDateActive(true);
        return; // skip `master_data_get` for custom range

      default:
        start_date = "";
        end_date = "";
        break;
    }

    setCustomDateActive(false);
    master_data_get(start_date, end_date);
  };

  const handleDateChange = (date) => {
    setStartDate(date);
  };

  function getFormattedLocalDate(dateString) {
    const dateObj = new Date(dateString); // Convert string to Date object
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const search_data = () => {
    master_data_get(
      getFormattedLocalDate(startDate),
      getFormattedLocalDate(endDate)
    );
  };

  const itemsPerPage = 5;

  // Filter transactions based on active tab
  const filteredTransactions = transactions.filter((transaction) => {
    if (activeTab === "all") return true;
    return transaction.status.toLowerCase() === activeTab.toLowerCase();
  });

  // Calculate pagination variables
  const totalItems = filteredTransactions.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // Calculate starting and ending indices
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  // Get transactions for current page
  const currentTransactions = filteredTransactions.slice(startIndex, endIndex);

  // Function to handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
  };

  // Generate pagination numbers
  const paginationNumbers = () => {
    const numbers = [];
    const maxVisiblePages = 3;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if less than maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i);
      }
    } else {
      // Always show first page
      numbers.push(1);

      // Determine middle range
      if (currentPage <= 2) {
        numbers.push(2);
        numbers.push(3);
        numbers.push("...");
      } else if (currentPage >= totalPages - 1) {
        numbers.push("...");
        numbers.push(totalPages - 2);
        numbers.push(totalPages - 1);
      } else {
        numbers.push("...");
        numbers.push(currentPage);
        if (currentPage < totalPages - 1) {
          numbers.push("...");
        }
      }

      // Always show last page if more than 1 page
      if (totalPages > 1 && !numbers.includes(totalPages)) {
        numbers.push(totalPages);
      }
    }

    return numbers;
  };
  const getMethodClass = (method) => {
    if (!method || typeof method !== "string")
      return "payment-ledger-method-default";

    switch (method.trim().toLowerCase()) {
      case "stripe":
        return "payment-ledger-method-stripe";
      case "cash":
        return "payment-ledger-method-cash";
      default:
        return "payment-ledger-method-default";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 0:
        return "payment-ledger-status-paid";
      case 1:
        return "payment-ledger-status-unpaid";
      default:
        return "payment-ledger-status-default";
    }
  };

  const handleViewDetails = (transaction) => {
    setSelectedTransaction(transaction);
    setShowModal(true);
  };

  const getActionButtons = (transaction) => {
    return (
      <button
        className="payment-ledger-btn payment-ledger-btn-view m-0"
        onClick={() => handleViewDetails(transaction)}
      >
        View Details
      </button>
    );
  };

  // ApexCharts options and series
  const getChartOptions = () => {
    // Prepare data for ApexCharts
    const categories = chartData.map((item) => item.name);
    const series = [
      {
        name: "Amount",
        data: chartData.map((item) => item.value),
      },
    ];

    // Calculate max value for y-axis with some padding
    const maxValue = Math.max(...chartData.map((item) => item.value)) * 1.2;
    // Round up to nearest multiple of 5
    const roundedMaxValue = Math.ceil(maxValue / 5) * 5;

    // Use dynamic y-axis labels from the API response if available
    let yaxisLabels = [];
    if (y_axis && Array.isArray(y_axis)) {
      // If API provides y-axis labels, round each to nearest multiple of 5
      yaxisLabels = y_axis.map((value) => Math.round(value / 5) * 5);
    } else {
      // Generate sensible intervals with values as multiples of 5
      const steps = 5;
      const stepSize = roundedMaxValue / steps;
      // Round stepSize to nearest multiple of 5
      const roundedStepSize = Math.ceil(stepSize / 5) * 5;

      for (let i = 0; i <= steps; i++) {
        yaxisLabels.push(roundedStepSize * i);
      }
    }

    return {
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: {
            show: false,
          },
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
          events: {
            mouseMove: function (event, chartContext, config) {
              // When hovering over a bar in the chart
              if (
                config.dataPointIndex !== -1 &&
                config.dataPointIndex !== hoveredBar
              ) {
                setHoveredBar(config.dataPointIndex);
              }
            },
            mouseLeave: function () {
              setHoveredBar(null);
            },
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 8,
            columnWidth: "40%",
            distributed: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: chartData.map((item) => item.color),
        dataLabels: {
          enabled: true,
          formatter: (val) => "$" + val.toLocaleString(),
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        legend: {
          show: false,
        },
        grid: {
          borderColor: "#f1f1f1",
          row: {
            colors: ["transparent", "transparent"],
          },
        },
        xaxis: {
          categories: categories,
          labels: {
            style: {
              fontSize: "12px",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          min: 0, // Ensure Y-axis starts from 0
          max: roundedMaxValue,
          tickAmount: yaxisLabels.length - 1,
          labels: {
            formatter: (val) => {
              // Round to nearest multiple of 5
              const roundedVal = Math.round(val / 5) * 5;

              if (roundedVal >= 1000) {
                return "$" + (roundedVal / 1000).toFixed(0) + "K";
              }
              return "$" + roundedVal;
            },
            style: {
              fontSize: "12px",
            },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => "$" + val.toLocaleString(),
          },
        },
        states: {
          hover: {
            filter: {
              type: "darken",
              value: 0.9,
            },
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: "darken",
              value: 0.35,
            },
          },
        },
      },
      series: series,
    };
  };
  // Get chart options and series
  const chartOptions = getChartOptions();

  // Get donut chart options and series for Payment Sources
  const getDonutChartOptions = () => {
    // Extract data for the donut chart
    const stripeValue = parseInt(paymentsource?.Stripe?.current) || 0;
    const cashValue = parseInt(paymentsource?.Cash?.current) || 0;

    const series = [stripeValue, cashValue];
    const totalValue = stripeValue + cashValue;

    return {
      options: {
        chart: {
          type: "donut",
          height: 250,
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        colors: ["#3C82F6", "#F59E0B"], // Primary (blue) for Stripe, Warning (amber) for Cash
        labels: ["Stripe", "Cash"],
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            return Math.round(val) + "%";
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "65%",
              background: "transparent",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: undefined,
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return "$" + val;
                  },
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Total Revenue",
                  fontSize: "16px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  fontWeight: 600,
                  color: "#373d3f",
                  formatter: function (w) {
                    return "$" + totalValue;
                  },
                },
              },
            },
          },
        },
        legend: {
          show: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        tooltip: {
          y: {
            formatter: function (value) {
              return "$" + value.toLocaleString();
            },
          },
        },
      },
      series: series,
    };
  };

  // Get donut chart options and series
  const donutChartOptions = getDonutChartOptions();

  return (
    <>
      <Header />
      {showLoaderAdmin && <Loader />}
      <div className="pageCntn_head">
        <div className="pageNameDiv">
          <p>Payment Analytics</p>

          <img src={GreyArrow || "/placeholder.svg"} alt="Rapid Car Leasing" />
        </div>
        <Button
          onClick={goBack}
          startIcon={<ArrowLeft size={17} style={{ marginBottom: "2px" }} />}
          className="Back_bttn_page"
        >
          Back
        </Button>
      </div>
      <div className="container-fluid py-4">
        {/* Enhanced Header Section */}
        <div className="mb-2 d-flex  justify-content-between align-items-center mb-4">
          <div className="analyticFIlter">
            <div className="col-xl-10">
              <div className="row m-0">
                <div className="col-md-4">
                  <div className="dropdownCustom" ref={dropdownRef}>
                    <div
                      onClick={(e) => {
                        setIsActive(!isActive);
                      }}
                      className="dropdownCustom-btn"
                    >
                      {Analytics_text.Period_text}: {selected.label}
                      <span
                        className={
                          isActive ? "fas fa-caret-up" : "fas fa-caret-down"
                        }
                      >
                        <img
                          src={dropdown || "/placeholder.svg"}
                          alt="Rapid Car Leasing"
                        />
                      </span>
                    </div>
                    <div
                      className="dropdownCustom-content"
                      style={{ display: isActive ? "block" : "none" }}
                    >
                      {options_select_drop_feedback.map(function (
                        items,
                        index
                      ) {
                        return (
                          <div
                            onClick={(e) => {
                              select_dropdown(items);
                            }}
                            className="itemDrop"
                            key={index}
                          >
                            {items.label}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
                {customDateActive && (
                  <>
                    <div className="col-md-3 bottomAlgin">
                      <div className="person__calenderFrame_image image_icon_position1 custn_possitin_icn ">
                        <DatePicker
                          selected={startDate}
                          onChange={handleDateChange}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-md-3 bottomAlgin">
                      <div className="person__calenderFrame_image image_icon_position1 custn_possitin_icn ">
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => setEndDate(date)}
                          className="form-control input_field_custom4"
                          maxDate={computeTodayDate()}
                          minDate={startDate}
                          dateFormat="MM-dd-yyyy"
                          placeholderText="MM-DD-YYYY"
                        />
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="downloadBtnAna ">
                        <button onClick={() => search_data()}>
                          {Analytics_text.Search_text}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Stats Cards */}
        <div className="row m-0 g-3">
          <div className="col-md-6 col-lg-3">
            <div className="card h-75 border-0">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                  <div>
                    <p className="text-gray-500 font-medium text-sm mb-0">
                      Total Collections
                    </p>
                    <h3 className=" font-bold text-gray-900 mb-0 cardhead">
                      ${totaldata.total_collections}
                    </h3>
                    {/* <div className="mt-1 d-flex align-items-center">
                      <span className="text-success d-flex align-items-center fw-medium me-2">
                        <ChevronUp size={16} className="me-1" />
                        {totaldata.collection_percentage}%
                      </span>
                      <span className="text-dark">vs {selected.label}</span>
                    </div> */}
                  </div>
                  <div>
                    {" "}
                    <div className=" p-3 rounded-circle text-white totalcard">
                      <DollarSign
                        size={24}
                        style={{ color: "var(--primary-color)" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-md-6 col-lg-3">
            <div className="card h-75 border-0">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                  <div>
                    <p className="text-gray-500 font-medium text-sm mb-0">
                      Outstanding Dues
                    </p>
                    <h3 className=" font-bold text-gray-900 mb-0 cardhead">
                      ${totaldata.outstanding_collections?.toFixed(2)}
                    </h3>
                    <div className="mt-1 d-flex align-items-center">
                      <span className="text-danger d-flex align-items-center fw-medium me-2">
                        <ChevronUp size={16} className="me-1" />
                        {totaldata.outstanding_percentage}%
                      </span>
                      <span className="text-dark">vs {selected.label}</span>
                    </div>
                  </div>
                  <div>
                    <div className="outcard p-3 rounded-circle text-white">
                      <AlertTriangle size={24} style={{ color: "#fc2f2f" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="col-md-6 col-lg-3">
            <div className="card h-75 border-0">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="text-gray-500 font-medium text-sm mb-0">
                        Stripe Collection
                      </p>
                      <h3 className="cardhead font-bold text-gray-900 mb-0">
                        ${totaldata.strip_collections}
                      </h3>
                      {/* <div className="mt-1 d-flex align-items-center">
                        <span className="text-success d-flex align-items-center fw-medium me-2">
                          <ChevronUp size={16} className="me-1" />
                          {totaldata.strip_percentage}%
                        </span>
                        <span className="text-dark">vs {selected.label}</span>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className="activecard p-3 rounded-circle text-white">
                      <Users size={24} style={{ color: "green" }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3">
            <div className="card h-75 border-0 shadow-md">
              <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="text-gray-500 font-medium text-sm mb-0">
                        Cash Collection
                      </p>
                      <h3 className="cardhead font-bold text-gray-900 mb-0">
                        ${totaldata.cash_collections}
                      </h3>
                      {/* <div className="mt-1 d-flex align-items-center">
                        <span className="text-success d-flex align-items-center fw-medium me-2">
                          <ChevronUp size={16} className="me-1" />
                          {totaldata.cash_percentage}%
                        </span>
                        <span className="text-dark">vs {selected.label}</span>
                      </div> */}
                    </div>
                  </div>
                  <div>
                    <div className="paymentcard p-3 rounded-circle text-white">
                      <CheckCircle
                        size={24}
                        style={{ color: "var(--primary-color)" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Payment Breakdown Chart and Recent Activity */}
        <div className="row g-3 m-0">
          <div className="col-lg-8">
            <div className="card border-0 shadow-sm h-90">
              <div className="card-header bg-white border-0 pt-4 pb-0">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h5 className="card-title0 mb-0 fw-bold text-dark">
                    Payment Breakdown by Service
                  </h5>
                </div>
              </div>
              <div className="card-body">
                {/* ApexCharts Bar Chart */}
                <div
                  className="chart-container position-relative mb-0"
                  style={{ height: "350px" }}
                >
                  {chartData && chartData.length > 0 && (
                    <Suspense fallback={<div>Loading chart...</div>}>
                      <ReactApexChart
                        ref={chartRef}
                        options={chartOptions.options}
                        series={chartOptions.series}
                        type="bar"
                        height={350}
                      />
                    </Suspense>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="card border-0 shadow-sm h-90">
              <div className="card-header bg-white border-0 pt-4 pb-0">
                <h5 className="card-title mb-0 fw-bold text-dark">
                  Payment From Sources
                </h5>
              </div>
              <div className="card-body">
                {/* ApexCharts Donut Chart */}
                <div
                  className="chart-container position-relative mb-0"
                  style={{ height: "250px" }}
                >
                  {paymentsource && Object.keys(paymentsource).length > 0 && (
                    <Suspense fallback={<div>Loading chart...</div>}>
                      <ReactApexChart
                        ref={donutChartRef}
                        options={donutChartOptions.options}
                        series={donutChartOptions.series}
                        type="donut"
                        height={250}
                      />
                    </Suspense>
                  )}
                </div>

                <div className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-primary rounded-circle me-2"
                        style={{ width: "12px", height: "12px" }}
                      ></div>
                      <span className="fw-medium text-dark">Stripe</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-bold me-2 text-primary">
                        ${paymentsource?.Stripe?.current}
                      </span>
                      <span className="fw-medium text-dark">
                        {paymentsource?.Stripe?.percent_change}%
                      </span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <div
                        className="bg-warning rounded-circle me-2"
                        style={{ width: "12px", height: "12px" }}
                      ></div>
                      <span className="fw-medium text-dark">Cash</span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span className="fw-bold me-2 text-warning">
                        ${paymentsource?.Cash?.current}
                      </span>
                      <span className="fw-medium text-dark">
                        {paymentsource?.Cash?.percent_change}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row g-3 m-0">
          {/* Enhanced Legend with Data Cards */}
          <div className="row g-3 m-0 mb-2">
            {chartData.map((item, index) => (
              <div className="col-lg col-sm-4" key={index}>
                <div
                  className="card border-4 shadow-sm h-60"
                  style={{
                    borderLeft: `4px solid ${item.color}`,
                    transform:
                      hoveredBar === index ? "scale(1.05)" : "scale(1)",
                    transition: "transform 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={() => setHoveredBar(index)}
                  onMouseLeave={() => setHoveredBar(null)}
                >
                  <div className="card-body p-3">
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className="rounded-circle me-2 flex-shrink-0"
                          style={{
                            width: "8px",
                            height: "8px",
                            backgroundColor: item.color,
                          }}
                        ></div>
                        <h6 className="mb-0 fw-bold">{item.name}</h6>
                      </div>
                      <span
                        className="badge"
                        style={{ backgroundColor: item.color }}
                      >
                        {item.percentage}%
                      </span>
                    </div>

                    <div className="d-flex justify-content-between align-items-end">
                      <span
                        className="h5 mb-0 fw-bold"
                        style={{ color: item.color }}
                      >
                        ${item.value.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Recent Activity Table */}
        <div className="payment-ledger-table-container">
          <div className="card-header bg-white border-0 pb-0 d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-3 text-dark">Recent Activity</h5>
          </div>

          <div className="payment-ledger-table-wrapper">
            <table className="payment-ledger-table">
              <thead>
                <tr>
                  <th className="payment-ledger-header">DATE</th>
                  <th className="payment-ledger-header">TRANSACTION ID</th>
                  <th className="payment-ledger-header">DESCRIPTION</th>
                  <th className="payment-ledger-header">METHOD</th>
                  <th className="payment-ledger-header">AMOUNT</th>
                  <th className="payment-ledger-header">Sources</th>
                  <th className="payment-ledger-header">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {currentTransactions.map((transaction, index) => (
                  <tr
                    className="payment-ledger-row"
                    key={transaction.primary_id}
                  >
                    <td className="payment-ledger-cell">
                      {formatDateStringdot(transaction.entry_date)}
                    </td>
                    <td className="payment-ledger-cell payment-ledger-transaction-id">
                      {transaction.transaction_id}
                    </td>
                    <td className="payment-ledger-cell">
                      {transaction.transaction_note}
                    </td>
                    <td className="payment-ledger-cell">
                      <span
                        className={`payment-ledger-method ${getMethodClass(
                          transaction.payment_mode
                        )}`}
                      >
                        {transaction.payment_mode}
                      </span>
                    </td>
                    <td className="payment-ledger-cell payment-ledger-amount">
                      ${transaction.total_amount}
                    </td>
                    <td className="payment-ledger-cell">
                      <span
                        className={`payment-ledger-status ${getStatusClass(
                          transaction.refund_status
                        )}`}
                      >
                        {transaction.refund_status == 1 ? "User" : "Admin"}
                      </span>
                    </td>
                    <td className="payment-ledger-cell payment-ledger-actions">
                      {getActionButtons(transaction)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="payment-ledger-pagination">
            <div className="payment-ledger-pagination-info">
              Showing {startIndex + 1} to {endIndex} of {totalItems} results
            </div>
            <div className="payment-ledger-pagination-controls">
              <button
                className="payment-ledger-pagination-btn payment-ledger-pagination-prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {paginationNumbers().map((number, index) =>
                number === "..." ? (
                  <button
                    key={`ellipsis-${index}`}
                    className="payment-ledger-pagination-btn payment-ledger-pagination-ellipsis"
                  >
                    ...
                  </button>
                ) : (
                  <button
                    key={number}
                    className={`payment-ledger-pagination-btn payment-ledger-pagination-number ${currentPage === number
                      ? "payment-ledger-pagination-active"
                      : ""
                      }`}
                    onClick={() => handlePageChange(number)}
                  >
                    {number}
                  </button>
                )
              )}

              <button
                className="payment-ledger-pagination-btn payment-ledger-pagination-next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Transaction Details Modal - Integrated directly in the component */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="transaction-details-modal"
      >
        <Modal.Header className="border-0 pb-0">
          <Modal.Title className="w-100 text-center">
            Transaction Details: {selectedTransaction?.primary_id}
          </Modal.Title>
          <Button
            variant="link"
            onClick={() => setShowModal(false)}
            className="close-button p-0 position-absolute"
          >
            <X size={20} color="#5B93FF" />
          </Button>
        </Modal.Header>
        {selectedTransaction && (
          <Modal.Body className="pb-4">
            <div className="status-section justify-content-between">
              <div className="status-section">
                <div className="status-icon-wrapper">
                  <CheckCircle
                    size={32}
                    color="#3C82F6"
                    className="status-icon"
                  />
                </div>
                <div className="status-info">
                  <h4 className="status-title">Payment Completed</h4>
                  <p className="status-date mb-0">
                    {formatDateStringdot(selectedTransaction.entry_date)} -{" "}
                    {formatTimeFormat(selectedTransaction.entry_date)}
                  </p>
                </div>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-md-6">
                <div className="details-card">
                  <h5 className="details-header mb-3">Transaction Details</h5>
                  <div className="details-list">
                    <div className="details-item">
                      <span className="detail-label">Amount:</span>
                      <span className="detail-value">
                        {selectedTransaction.total_amount}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="detail-label">Payment Method:</span>
                      <span className="detail-value">
                        {selectedTransaction.payment_mode}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="detail-label">Payment For:</span>
                      <span className="detail-value">
                        {selectedTransaction.transaction_note}
                      </span>
                    </div>
                    <div className="details-item">
                      <span
                        className="detail-label"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Transaction ID:
                      </span>
                      <span
                        className="detail-value"
                        style={{
                          wordWrap: "break-word",
                          overflowWrap: "break-word",
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {selectedTransaction.transaction_id}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="details-card">
                  <h5 className="details-header mb-3">Driver Information</h5>
                  <div className="details-list">
                    <div className="details-item align-items-center mb-3">
                      <div className="d-flex align-items-center">
                        <div>
                          <div className="fw-medium">
                            {selectedTransaction?.booking_data?.name}
                          </div>
                          <div className="text-muted small">
                            #JD{selectedTransaction?.booking_data?.user_id}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="details-item">
                      <span className="detail-label">Payment Plan:</span>
                      <span className="detail-value">
                        {selectedTransaction?.booking_data?.payment_day_week ==
                          1
                          ? "Daily"
                          : "weekly"}{" "}
                        (${selectedTransaction?.booking_data?.per_day_rent}/
                        {selectedTransaction?.booking_data?.payment_day_week ==
                          1
                          ? "Day"
                          : "week"}
                        )
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="detail-label">Email:</span>
                      <span className="detail-value">
                        {selectedTransaction?.booking_data?.email}
                      </span>
                    </div>
                    <div className="details-item">
                      <span className="detail-label">Phone:</span>
                      <span className="detail-value">
                        {selectedTransaction?.booking_data?.mobile_no}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-12">
                <div className="details-card">
                  <h5 className="details-header mb-3">Transaction Details</h5>
                  <div className="details-list">
                    <div className="details-item">
                      <span className="detail-label">Transaction ID:</span>
                      <span className="detail-value">
                        {selectedTransaction.transaction_id}
                      </span>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Modal.Body>
        )}
      </Modal>
    </>
  );
};

export default PaymentDashboard;
